import React, { useEffect } from 'react'
import styled from 'styled-components'
import banner from '../../images/banner.jpg'
import {Form} from 'antd'
import { useDispatch, useSelector } from 'react-redux';
import { bannerSelector, fetchAllBanner} from '../../api/bannerSlice'


// swiper imports
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css/effect-fade";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Autoplay, Pagination, EffectFade } from "swiper";
import "../../index.css";
// import { Swiper, SwiperSlide } from 'swiper/react/swiper-react';
// import 'swiper/swiper-bundle.min.css'
// import "swiper/swiper.min.css";
// import 'swiper/modules/effect-fade/effect-fade'
// import "swiper/modules/navigation/navigation";
// import "swiper/modules/navigation/navigation";
// import { Autoplay, Pagination, EffectFade } from "swiper";
import { NavLink } from 'react-router-dom';


export default function Header() {
    return(
        <div  className="container md:px-5 px-2 md:py-12 py-4 mx-auto lg:w-4/5 block"
        >
            

    <Swiper
        slidesPerView={1}
        spaceBetween={10}
        loop={true}
        effect={"fade"}
        loopFillGroupWithBlank={true}
        grabCursor={true}
        autoplay={{
            delay: 2500,
            disableOnInteraction: false,
          }}
        pagination={{
          clickable: true,
        }}
        breakpoints={{
          "@0.00": {
            slidesPerView: 1,
            spaceBetween: 10,
          },
          "@0.75": {
            slidesPerView: 1,
            spaceBetween: 10,
          },
          "@1.00": {
            slidesPerView: 1,
            spaceBetween: 20,
          },
          "@1.50": {
            slidesPerView: 1,
            spaceBetween: 30,
          },
        }}
        modules={[Pagination, Autoplay, EffectFade]}
        className="mySwiper"
      >
 <SwiperSlide>
    <NavLink to='/e-vouchers'>      
   <img alt="gallery"  className="w-full rounded-md cursor-pointer object-cover md:h-[20vh] h-[25vh]  lg:h-[45vh] object-center block  inset-0" src={'https://firebasestorage.googleapis.com/v0/b/elegant-user.appspot.com/o/images%2Fw%20banner-05.jpg?alt=media&token=8bf1d33f-cddd-43d8-90bd-78fc4038bef9'}/>
   </NavLink>   
  </SwiperSlide>
  <SwiperSlide>
  <NavLink to='/e-vouchers'>      
   <img alt="gallery"  className="w-full rounded-md cursor-pointer object-cover md:h-[20vh] h-[25vh]  lg:h-[45vh] object-center block  inset-0"  src={'https://firebasestorage.googleapis.com/v0/b/elegant-user.appspot.com/o/images%2Fw%20banner-05.jpg?alt=media&token=8bf1d33f-cddd-43d8-90bd-78fc4038bef9'}/>
   </NavLink>      
  </SwiperSlide>
  <SwiperSlide>
  <NavLink to='/e-vouchers'>     
   <img alt="gallery"  className="w-full rounded-md cursor-pointer object-cover md:h-[20vh] h-[25vh]  lg:h-[45vh] object-center block  inset-0"  src={'https://firebasestorage.googleapis.com/v0/b/elegant-user.appspot.com/o/images%2Fbanner-03.jpg?alt=media&token=3408318d-863d-48e8-9024-c1219ebe865a'}/>
   </NavLink>      
  </SwiperSlide>
  <SwiperSlide>
  <NavLink to='/e-vouchers'>      
   <img alt="gallery"  className="w-full rounded-md cursor-pointer object-cover md:h-[20vh] h-[25vh]  lg:h-[45vh] object-center block  inset-0" src={'https://firebasestorage.googleapis.com/v0/b/elegant-user.appspot.com/o/images%2Fbanner-09.jpg?alt=media&token=002fafde-b79c-4c5e-b2a9-2f269a021edc'}/>
   </NavLink>      
  </SwiperSlide>

</Swiper>
{/* <div  className="flex flex-wrap w-full md:mt-5 mt-3" >
        <div className="md:p-2 p-1 w-1/2 overflow-hidden rounded-md ">
        <img alt="gallery" className="w-full object-cover cursor-pointer  transition duration-300 hover:scale-[1.1] rounded-md shadow-sm h-[16h] md:h-[26vh] lg:h-[36vh] object-center block" src={'https://firebasestorage.googleapis.com/v0/b/elegant-user.appspot.com/o/images%2Fweb%20card-02%20(1).png?alt=media&token=cb7f3b07-efa0-48db-9df0-5f78a9235cdb'}/>
        <img alt="gallery" className="w-full object-cover cursor-pointer  transition duration-300 hover:scale-[1.1] rounded-md shadow-sm h-[16h] md:h-[26vh] lg:h-[36vh] object-center block"  src={'https://firebasestorage.googleapis.com/v0/b/elegant-user.appspot.com/o/images%2Fweb%20card-01%20(1).png?alt=media&token=0bf6201c-1bf2-409a-a743-5d4f241da2d2'}/>
        </div>
      </div> */}
      <div className="flex flex-wrap w-full md:mt-5 mt-3 justify-between " >
       <div className="md:p-1 p-1 w-1/2 overflow-hidden rounded-md md:block hidden ">
        <NavLink to='/products-gifts'>
        <img alt="gallery" className="w-full object-cover cursor-pointer  transition duration-300 hover:scale-[1.1] rounded-md shadow-sm h-[16h] md:h-[26vh] lg:h-[36vh] object-center block" src={'https://firebasestorage.googleapis.com/v0/b/elegant-user.appspot.com/o/images%2Fweb%20card-02%20(1).png?alt=media&token=cb7f3b07-efa0-48db-9df0-5f78a9235cdb'}/>
        </NavLink>
        </div>
        <div className="md:p-1 p-1 w-1/2 overflow-hidden rounded-md md:block hidden ">
        <NavLink to='/products-gifts'>
        <img alt="gallery" className="w-full object-cover cursor-pointer  transition duration-300 hover:scale-[1.1] rounded-md shadow-sm h-[16h] md:h-[26vh] lg:h-[36vh] object-center block" src={'https://firebasestorage.googleapis.com/v0/b/elegant-user.appspot.com/o/images%2Fweb%20card-01%20(1).png?alt=media&token=0bf6201c-1bf2-409a-a743-5d4f241da2d2'}/>
        </NavLink>
        </div>
      </div>
    </div>
    )
}

// export default function Header() {

//     const dispatch = useDispatch()
// const {all_banner, loading} = useSelector(bannerSelector)
// const [form] = Form.useForm();

// // const {id} = useParams()
// console.log(all_banner);


// useEffect(()=>{

//     dispatch(fetchAllBanner())
    
//     }, [dispatch])

//     return (
//         <HeaderWrap className="container-fluid image" style={{backgroundImage:`url('${all_banner.image}')`}}>
//             <div className="text">
//             <h6 className="m-0">{all_banner.title}</h6>
//             <h1 className="m-0 text-uppercase"><b><i>{all_banner.sub_title}</i></b></h1>
//             </div>
//         </HeaderWrap>
//     )
// }

// const HeaderWrap = styled.div`

// background-size:100%;
// height:300px;
// position:relative;


// &::after{
//     position: absolute;
    
//     top: 50%;
//     left: 50%;
//     transform: translate(-50%, -50%);
//     content: "";
//     background:linear-gradient(98deg,rgba(2,0,36,0) 0%,rgb(236 236 236 / 78%) 95%,rgb(255 255 255 / 85%) 100%);
//     z-index: 1;
//     width: 100%;
//     height: 100%;
// }

// .text{
// position:absolute;
// top:50%;
// right:20%;
// text-align:right;
// z-index: 2;

// h1{
//     color:#88448a;
//     font-size:2.5rem;
// font-weight:400;
// }
// h6{
//     font-size:1.3rem;

// }
// }

// ` 